var map = {
	"./ca.json": "dIsJ",
	"./en.json": "gF9L",
	"./es.json": "6eQA",
	"./fr.json": "Bi37",
	"./it.json": "tJ+Y",
	"./pt.json": "pXP3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zzse";


//////////////////
// WEBPACK FOOTER
// ./locale ^\.\/.*\.json$
// module id = zzse
// module chunks = 2